import { Department } from '@/modules/department'
import { User } from '@/modules/user'
import { BaseResource, ProjectClassification, ResourcePermission, ResourceType, Team } from '@/schemas'
import { GetTransformedEnumObjEnumType, getTransformedEnumObj } from '@/utils/enum-obj-transform'

import { DimensionType } from '../dimensions'
import { ProductionRole } from '../production-project/production.schema'

export enum DevlopStatus {
  未开始 = 0,
  进行中 = 1,
  已结项 = 2,
  暂停 = 3,
  // '终止' = 6,
}

export const DevlopLegacyClassificationObj = {
  SDK基础质量: 1,
  QoE改进: 2,
  大网基础质量: 3,
  后台媒体服务质量: 4,
  研发效能提升: 5,
  问题解决: 6,
  成本优化: 7,
} as const

export const DevlopClassification = getTransformedEnumObj({
  ...DevlopLegacyClassificationObj,
  ...ProjectClassification,
})

export type DevlopClassificationType = GetTransformedEnumObjEnumType<typeof DevlopClassification, string>

export enum DevlopStage {
  Alpha = 1,
  Beta = 2,
  Mature = 3,
}

export enum DevlopReviewType {
  产品审批 = 1,
  研发审批 = 2,
}

export enum ReviewFormActions {
  创建 = 0,
  通过 = 1,
  驳回 = 2,
  完成 = 3,
}

export interface Review {
  id: number
  comment: string
  date: string
  action: ReviewFormActions
  type: DevlopReviewType
  reason?: string
  createdAt: string
  updatedAt: string
  email: string
  user?: { name: string; email: string }
}

export interface Devlop extends BaseResource, ResourcePermission {
  id: number
  selfId: string
  name: string
  email: string
  departmentId: number
  type: number
  to: string
  pgm: string
  startDate: Date
  endDate: Date
  progress: number
  classification: number
  challenge: string
  status: DevlopStatus
  jql: string | null

  thisWeekReport: any

  readPermissions?: string[]

  background: string
  goal: string
  standard: string

  createdAt: Date
  updatedAt: Date
  deletedAt?: any
  typeName: string
  user: User
  department: Department
  cycle: Cycle

  isFavourited: boolean

  risk: any
  lastestWrite: any
  resources: DevlopEstimateResource[]
  businessReport?: {
    report: string
    createTime: string
  }

  dimensions: {
    id: number
    projectSelfId: string
    resourceType: ResourceType
    dimensionId: number
    percentage: number
    dimension: {
      id: number
      name: string
      type: DimensionType
    }
  }[]
  hots: any[]
}
export interface DevlopEstimateResourceUser {
  estimateResourceId: number
  email: string
}

export interface DevlopEstimateResource {
  id: number
  teamSelfId: string
  workload: number
  startDate: string
  endDate: string
  department?: Team
  users?: DevlopEstimateResourceUser[]
}

interface Cycle {
  name: string
  cycleId: number
}

export const DevlopRole = {
  ...ProductionRole,
} as const
